import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

// Overlay das trocas de tela. As paginas buscam os dados no ngOnInit/ngAfterViewInit,
// entao esconder no NavigationEnd deixaria a tela vazia na frente do usuario: fica
// visivel do inicio da navegacao ate as chamadas da nova pagina terminarem.
@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  active: boolean = false;

  // as requisicoes so seguram o overlay durante uma troca de tela; assim o "VER MAIS"
  // das listas e o envio do formulario continuam com o loading proprio deles
  emTransicao: boolean = false;

  navegando: boolean = false;
  pendentes: number = 0;

  mostradoEm: number = 0;
  timer: any = null;

  browser: boolean;

  // o contador zera no intervalo entre uma chamada e a proxima, e o overlay piscaria
  readonly ATRASO_PARA_ESCONDER = 200;
  // telas que nao buscam nada terminam antes de dar tempo de ver o gif
  readonly TEMPO_MINIMO_VISIVEL = 400;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    public router: Router
  ) {
    this.browser = isPlatformBrowser(platformId);

    // no server o overlay nunca liga, entao nao vai parar no HTML renderizado
    if (!this.browser) {
      return;
    }

    this.router.events.subscribe(evento => {
      if (evento instanceof NavigationStart) {
        this.navegando = true;
        this.emTransicao = true;
        this.mostrar();
      }
      if (evento instanceof NavigationEnd || evento instanceof NavigationCancel || evento instanceof NavigationError) {
        this.navegando = false;
        this.avaliar();
      }
    });
  }

  requisicaoIniciou() {
    this.pendentes++;
    if (this.emTransicao) {
      this.mostrar();
    }
  }

  requisicaoTerminou() {
    this.pendentes = Math.max(0, this.pendentes - 1);
    if (this.emTransicao) {
      this.avaliar();
    }
  }

  mostrar() {
    clearTimeout(this.timer);
    this.timer = null;

    if (!this.active) {
      this.active = true;
      this.mostradoEm = Date.now();
    }
  }

  // esconde quando a navegacao acabou e nao ha mais nada carregando
  avaliar() {
    if (this.navegando || this.pendentes > 0 || this.timer) {
      return;
    }

    this.timer = setTimeout(() => {
      this.timer = null;

      if (this.navegando || this.pendentes > 0) {
        return;
      }

      const restante = this.TEMPO_MINIMO_VISIVEL - (Date.now() - this.mostradoEm);
      if (restante > 0) {
        this.timer = setTimeout(() => {
          this.timer = null;
          this.esconder();
        }, restante);
        return;
      }

      this.esconder();
    }, this.ATRASO_PARA_ESCONDER);
  }

  esconder() {
    this.active = false;
    this.emTransicao = false;
  }
}
